/*
 * Farida Gupta - "Image slider with content" carousel (theme/sections/fg-image-slider-with-content.liquid).
 *
 * Extends theme.js's <effect-carousel> (imported through the "theme" import map rather than
 * duplicated) purely to swap its default cross-fade for a horizontal push-slide: the leaving
 * slide and the entering slide translateX past each other in the direction of travel, with no
 * opacity/fade component. Autoplay, swipe and keyboard navigation come from the base class
 * untouched.
 */
import { timeline } from 'vendor';
import { EffectCarousel } from 'theme';

class FgImageSliderWithContentCarousel extends EffectCarousel {
  createOnChangeAnimationControls(fromSlide, toSlide, { direction } = {}) {
    const exitOffset = direction === 'previous' ? '100%' : '-100%';
    const enterFrom = direction === 'previous' ? '-100%' : '100%';

    return timeline([
      [fromSlide, { transform: ['translateX(0)', `translateX(${exitOffset})`] }, { duration: 0.4, easing: 'ease-in-out' }],
      [toSlide, { transform: [`translateX(${enterFrom})`, 'translateX(0)'] }, { duration: 0.4, at: '<', easing: 'ease-in-out' }],
    ]);
  }
}

if (!window.customElements.get('fg-image-slider-with-content-carousel')) {
  window.customElements.define('fg-image-slider-with-content-carousel', FgImageSliderWithContentCarousel);
}
